// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-clear-button-align {
  display: flex;
}

.dj-task-header {
  background-color: rgb(237, 244, 250);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 25px;
  width: 100%;
}
.dj-task-header .add-file {
  color: #003da5;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  font-weight: bold;
  background: transparent;
  border: none;
}
.dj-task-header .add-file:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/components/AWMJobs/DesignJobs/CloneJobs.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AACI;EACE,mBAAA;EACA,YAAA;AACN","sourcesContent":[".p-clear-button-align {\n  display: flex;\n}\n\n.dj-task-header {\n  background-color: rgb(237, 244, 250);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 25px;\n  width: 100%;\n\n  .add-file {\n    color: #003da5;\n    font-size: 14px;\n    font-style: normal;\n    line-height: normal;\n    font-weight: bold;\n    background: transparent;\n    border: none;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
